<template>
    <div class="chat-picture" :class="{ 'chat-picture--single-blocked': users.length === 1 && users[0].dislike }" :style="{ height: h, width: w }">
        <div
            v-for="(avatar, index) in avatars" :key="avatar.id + '-' + index"
            :style="avatar.style"
            :class="{ 'chat-picture--blocked': avatar.dislike }"
        ></div>
    </div>
</template>

<script>
export default {
  props: {
    users: {
      type: Array[Object],
      default: () => ([]),
    },
    w: { type: String, default: '' },
    h: { type: String, default: '' },
  },
  computed: {
    avatars() {
      try {
        const config = [
          [100, 100],
          [50, 100],
          [50, 50],
          [50, 50],
        ]

        const users = this.users.slice(0)

        // Cleanup this id 000-0000-0000... bullshit
        users.forEach(user => {
          if (!user.avatar_id || user.avatar_id.replace(/[0-]+/, '') === '') user.avatar_id = null
        })

        // Get users with a picture first
        users.sort((a, b) => {
          if (a.avatar_id && b.avatar_id) return 0
          if (b.avatar_id) return 1
          return -1
        })

        // Convert 4 users to { id, style, dislike }
        const res = []
        for (let i = 0, l = users.length; i < 4 && i < l; i++) {
          const user = users[i]

          const style = {}
          if (user.avatar_id) {
            style.backgroundColor = '#' + (user.avatar_color | 0x1000000).toString(16).substring(1)
            style.backgroundImage = `url(/image/${user.avatar_id}/172/172)`
          } else {
            style.backgroundColor = '#FFF'
            style.backgroundImage = 'url(/static/images/picto-profil-situation-2.svg)'
          }

          // Two per line
          let cfg = null
          if (l > 3) { cfg = config[3] } else { cfg = config[l - 1] }

          style.width = cfg[0] + '%'
          style.height = cfg[1] + '%'
          if (i === 0 && l === 3) {
            style.width = '100%'
          }

          res.push({
            id: user.id,
            dislike: user.dislike,
            style,
          })
        }
        return res
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss">
.chat-picture {
    overflow: hidden;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    position: relative;
    border-radius: 50%;

    > div {
        background-size: cover;
        background-position: center center;
    }

	  &--blocked {
        filter: grayscale(100%);
    }
    &--single-blocked::after {
        content: '';
        display: block;
        width: 142%;
        transform: rotate(45deg);
        height: 3px;
        position: absolute;
        top: 0;
        background: $red;
        left: 0;
        transform-origin: 0 0;
	}
}
</style>
